const ApiDocEmpregados = () => {
    const token = localStorage.getItem('@BI:Token');

    return (
        <div className="p-6 surface-card">
            <h1 className="text-2xl font-display font-bold text-primary mb-4">Documentação da API: Empregados</h1>

            <div className="mb-6">
                <h2 className="text-lg font-display font-semibold text-foreground">Endpoint</h2>
                <pre className="bg-muted p-4 rounded-lg text-sm font-mono text-foreground">GET 172.20.40.60:8080/api/relatorios/empregados</pre>
            </div>

            <div className="mb-6">
                <h2 className="text-lg font-display font-semibold text-foreground">Descrição</h2>
                <p className="text-muted-foreground">Retorna uma lista de empregados filtrados por código da empresa, nome, cargos e status de ativo.</p>
            </div>

            <div className="mb-6 table-responsive">
                <h2 className="text-lg font-display font-semibold text-foreground">Parâmetros</h2>
                <table className="w-full text-left border border-border rounded-lg ">
                    <thead className="bg-table-header text-table-header-fg">
                        <tr>
                            <th className="p-2">Nome</th>
                            <th className="p-2">Tipo</th>
                            <th className="p-2">Obrigatório</th>
                            <th className="p-2">Descrição</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr className="border-t border-border">
                            <td className="p-2 font-mono">empCodigo</td>
                            <td className="p-2">String</td>
                            <td className="p-2">Não</td>
                            <td className="p-2">Código da empresa</td>
                        </tr>
                        <tr className="border-t border-border">
                            <td className="p-2 font-mono">nome</td>
                            <td className="p-2">String</td>
                            <td className="p-2">Não</td>
                            <td className="p-2">Nome do empregado</td>
                        </tr>
                        <tr className="border-t border-border">
                            <td className="p-2 font-mono">cargos</td>
                            <td className="p-2">Lista&lt;String&gt;</td>
                            <td className="p-2">Não</td>
                            <td className="p-2">Lista de cargos para filtro</td>
                        </tr>
                        <tr className="border-t border-border">
                            <td className="p-2 font-mono">ativos</td>
                            <td className="p-2">Boolean</td>
                            <td className="p-2">Não</td>
                            <td className="p-2">Filtrar apenas empregados ativos</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="mb-6">
                <h2 className="text-lg font-display font-semibold text-foreground">Exemplo de Requisição</h2>
                <pre className="bg-muted p-4 rounded-lg text-sm font-mono text-foreground">
                    {`GET /api/relatorios/empregados?empCodigo=0164&nome=João&cargos=MOTORISTA%20I&cargos=ENCARREGADO&ativos=true`}
                </pre>
            </div>
            <div className="mb-6">
                <h2 className="text-lg font-display font-semibold text-foreground">Token</h2>
                <p className="bg-muted p-4 rounded-lg text-sm font-mono text-foreground break-all"><strong>Bearer</strong> {token}</p>
            </div>

        </div>
    );
};

export default ApiDocEmpregados;
